export default __webpack_public_path__ + "static/media/icon-sales-return.b25aee5b.svg";